module.exports = __webpack_public_path__ + "media/src/images/new_window-d30ef82fe7a5a20ed67ff1f034b2a85b.png";